import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import Series from 'pages/Home/Series'
import React from 'react'

export interface SeriesAdminControlsProps {
  openDeleteSeriesDialog: (series: Series)=> void
  openEditSeriesDialog: (series: Series)=> void
  series: Series
}

export default function SeriesAdminControls(props: SeriesAdminControlsProps) {
  const { openDeleteSeriesDialog, openEditSeriesDialog, series } = props

  return (
    <div>
      <ControlButton
        variant="edit"
        size="small"
        onClick={() => openEditSeriesDialog(series)}
        style={{ top: '-22px', left: '-2px' }}
      />
      <ControlButton
        variant="delete"
        size="small"
        onClick={() => openDeleteSeriesDialog(series)}
        style={{ top: '-22px', left: '20px' }}
      />
    </div>
  )
}
